import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '@environments/environment';

import { routes } from '@model/constants/routes';

@Injectable({
  providedIn: 'root',
})
export class FinalDecisionService {
  apiUrl = environment.apiUrl;
  private readonly headers = new HttpHeaders({
    'Content-Type': 'application/json',
  });

  constructor(private readonly http: HttpClient) {}

  public getDataTerms(): any {
    return this.http.get<any>(this.apiUrl + routes.getDataTermsFinalDecision, { headers: this.headers });
  }

  public getLeftDaysToNewLoanApplication(email: any): any {
    return this.http.get<any>(this.apiUrl + routes.getLeftDaysToNewLoanApplication + email, { headers: this.headers });
  }
}
